<template>
  <div class="row">
    <v-layout row wrap>
      <v-flex lg12 sm12 md12 xs12>
        <v-container>
          <v-card flat>
            <v-container>
              <h4 class="earth-color">{{$singleUserType.name}}</h4>
              <p class="">{{$singleUserType.description}}</p>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-card-title>
              Unassigned Features
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="search"
                text="Search"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="columns"
              :items="unAssigned"
              :search="search"
              :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
            >
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{props.item.menu}}</td>
                <td>{{props.item.name}}</td>
                <td>
                  <v-btn :depressed="true" color="info" small @click="addRole(props.item.public_id)">Add Feature</v-btn>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-card-title>
              Selected Role's Features
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="search"
                text="Search"
                single-line
                hide-details
                v-model="search2"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="columns"
              :items="currenctRoles"
              :search="search2"
              :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
            >
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{props.item.menu_name}}</td>
                <td>{{props.item.name}}</td>
                <td>
                  <v-btn :depressed="true" color="error" small @click="detachRole(props.item.public_id)">Remove Feature</v-btn>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search2 }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <!--{{featuresNotAdded}}-->
  </div>
</template>

<script>
export default {
  name: 'roles',
  data () {
    return {
      search: '',
      search2: '',
      columns: [
        {
          text: 'Menu Name',
          value: 'name'
        },
        {
          text: 'Feature',
          value: 'name'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_user_type', this.$route.params.role_id)
    this.$store.dispatch('get_user_type_features', this.$route.params.role_id)
    this.$store.dispatch('get_not_assigned_features', this.$route.params.role_id)
  },
  methods: {
    addRole: function (featureId) {
      var data = {
        feature_public_id: featureId,
        role_public_id: this.$route.params.role_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('assign_feature', data)
    },
    detachRole: function (publicId) {
      var data = {
        feature_public_id: publicId,
        role_public_id: this.$route.params.role_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('detach_feature', data)
    }
  }
}
</script>

<style scoped>

</style>
